import React from 'react';
import './FilterControls.css';

interface FilterOption {
  label: string;
  value: string;
}

interface FilterControlsProps {
  options: FilterOption[];
  activeFilter: string;
  onFilterChange: (value: string) => void;
}

const FilterControls: React.FC<FilterControlsProps> = ({ options, activeFilter, onFilterChange }) => {
  return (
    <div className="filter-controls">
      {options.map((option) => (
        <button
          key={option.value}
          className={`filter-btn ${activeFilter === option.value ? 'active' : ''}`}
          onClick={() => onFilterChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default FilterControls;
